module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"watchCandidates":"Watch candidates","watchInterview":"Watch interviews","restore":"Restore","copy":"Copy","vacancyRestored":"Job restored","vacancyCloned":"Job copied","yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
